import Marquee from "react-fast-marquee";
import { HOME } from "@/constants/testIds";

const EditorialMarquee = () => {
  return (
    <section data-testid={HOME.marquee} className="relative py-16 border-y border-white/5 overflow-hidden">
      <Marquee speed={26} gradient={false}>
        {["ZERO WASTED SPEND", "MULTI-APP GROWTH", "VIRAL VIDEO SCRIPTS", "ASO ENGINEERED", "$5/DAY TESTS"].map((t, i) => (
          <span key={i} className="font-display text-4xl sm:text-6xl font-black text-white/10 mx-16 whitespace-nowrap">
            {t}
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
